module.exports = __webpack_public_path__ + "img/new-updated.385bd5d1.png";